/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import { ButtonGroup } from '@atlaskit/button';
import ErrorIcon from '@atlaskit/icon/core/migration/error';
import { Button } from '../../../common/ui/Button';
import { EditButton } from './edit-button';
import { messages } from './messages';
import { SubmitButton } from './submit-button';
var formFooterWrapperStyles = css({
  display: 'flex',
  marginTop: "var(--ds-space-300, 24px)",
  justifyContent: 'flex-end'
});
var errorStyles = css({
  display: 'flex',
  alignItems: 'center',
  marginRight: 'auto'
});
/**
 * Footer for the Create Form, used as a wrapper for action buttons
 * and form error messages. This component is unmounted if
 * hideFooter is true in the Create Form.
 */
export function CreateFormFooter(_ref) {
  var formErrorMessage = _ref.formErrorMessage,
    handleCancel = _ref.handleCancel,
    testId = _ref.testId;
  var intl = useIntl();
  return jsx("footer", {
    "data-testid": "".concat(testId, "-footer"),
    css: formFooterWrapperStyles
  }, formErrorMessage && jsx("div", {
    role: "alert",
    css: errorStyles,
    "data-testid": "".concat(testId, "-error")
  }, jsx(ErrorIcon, {
    label: formErrorMessage,
    color: "var(--ds-icon-danger, #E34935)",
    spacing: "spacious"
  }), formErrorMessage), jsx(ButtonGroup, null, jsx(Button, {
    type: "button",
    actionSubjectId: "cancel",
    appearance: "subtle",
    onClick: function onClick(e) {
      e.stopPropagation();
      handleCancel();
    },
    testId: "".concat(testId, "-button-cancel")
  }, intl.formatMessage(messages.close)), jsx(EditButton, null), jsx(SubmitButton, null)));
}